import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const NoticeWrapper = styled.div`
  background-color: white;
  width: 90%;
  padding: 20px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    flex-direction: column; /* 작은 화면에서 수직 정렬 */
    align-items: flex-start; /* 왼쪽 정렬 */
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 20px;
  width: 100%;
  border-bottom: 1px solid #dddddd;

  @media (max-width: 768px) {
    flex-direction: column; /* 작은 화면에서 수직 정렬 */
    align-items: flex-start; /* 왼쪽 정렬 */
  }
`;

const Title = styled.h2`
  margin: 0;
  @media (max-width: 425px) {
    font-size: 1.5rem; /* 작은 화면에서 폰트 크기 조정 */
  }
`;

const SubTitle = styled.p`
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 0px;
  margin-left: 5px;

  @media (max-width: 768px) {
    margin-left: 0; /* 작은 화면에서 왼쪽 마진 제거 */
    margin-top: 0.5rem; /* Title 아래로 내려가면서 여백 추가 */
  }
`;

const Divider = styled.div`
  width: 100%;
  border-bottom: 2px solid #3498db;
`;

const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

const CountWrapper = styled.div`
  text-align: left;
  color: #555;
  font-size: 0.8rem;
`;

const Select = styled.select`
  margin-right: 0.5rem;
  padding: 0.5rem;

  @media (max-width: 425px) {
    width: 30%; /* 작은 화면에서 폭 조정 */
  }
`;

const Input = styled.input`
  padding: 0.5rem;
  margin-right: 0.5rem;

  @media (max-width: 425px) {
    width: 50%; /* 작은 화면에서 폭 조정 */
    margin-right: 0.5rem; /* 마진 조정 */
  }
`;

const Button = styled.button.attrs({ type: 'button' })`
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 425px) {
    width: 18%; /* 작은 화면에서 폭 조정 */
    padding: 0.5rem; /* 패딩 조정 */
  }
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: #3b5998;

  &:hover {
    text-decoration: underline;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
`;

const Thead = styled.thead`
  tr {
    border-bottom: 1px solid #ddd;
  }
`;

const Th = styled.th`
  padding: 0.5rem;
  text-align: center;
  font-size: 0.8rem;
  color: #555;
  width: ${({ width }) => width || 'auto'};
`;

const Tbody = styled.tbody`
  tr {
    border-bottom: 1px solid #ddd;
  }
`;

const Td = styled.td`
  text-align:center;
  padding: 0.5rem;
  font-size: 0.8rem;

  &:nth-child(2) a {
    color: #3b5998;
    text-decoration: none;
  }

  &:nth-child(2) a:hover {
    text-decoration: underline;
  }
`;

const DetailWrapper = styled.div`
  padding: 1rem;
`;

const DetailHeader = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const DetailInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const CommentCard = styled.div`
  background: white;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 14px;
`;

const ReplyCard = styled.div`
  margin-left: 20px;
  background-color: #f8f9fa;
  border-left: 3px solid #007bff;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 12px;
`;

const DeleteButton = styled.button.attrs({ type: 'button' })`
  background-color: #dc3545;
  font-size: 12px;
  padding: 4px 8px;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  &:hover {
    background-color: #c82333;
  }
`;

const EditButton = styled.button.attrs({ type: 'button' })`
  background-color: #007bff;
  font-size: 12px;
  padding: 4px 8px;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  transition: background-color 0.3s, transform 0.1s;
  &:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(1px);
  }
`;

const TextArea = styled.textarea`
  width: calc(100% - 60px);
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  resize: vertical;
  margin-right: 8px;
  font-size: 14px;
`;

const EditTextArea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  resize: vertical;
  margin-right: 8px;
  font-size: 14px;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`;
export default function CSCenterNotice() {
  const [faqs, setFaqs] = useState([]);
  const [searchType, setSearchType] = useState('title');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태 추가
  const [totalPages, setTotalPages] = useState(1);   // 총 페이지 수 상태 추가
  const [totalCount, setTotalCount] = useState(0);   // 총 게시물 수 상태 추가

  useEffect(() => {
    fetchNotices(searchType, searchTerm, currentPage);
  }, [currentPage]); // currentPage가 변경될 때마다 데이터 fetch

  const fetchNotices = (type = '', term = '', page = 1, limit = 10) => {
    let url = `/api/getNoticePage?page=${page}&limit=${limit}`;
    if (type && term) {
      url += `&type=${type}&term=${term}`;
    }
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        //console.log('Fetched data:', data);
        if (Array.isArray(data.posts)) {
          setFaqs(data.posts);
          setTotalPages(data.totalPages);
          setTotalCount(data.total);
        } else {
          console.error('Unexpected data format:', data);
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching FAQs:', error);
        setFaqs([]);
      });
  };

  const handleSearch = () => {
    setCurrentPage(1); // 검색 시 페이지를 1로 초기화
    fetchNotices(searchType, searchTerm, 1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <NoticeWrapper>
      {/* 기존 코드 그대로 유지 */}
      <HeaderWrapper>
        <TitleWrapper>
          <Title>공지사항</Title>
          <SubTitle>예매전 반드시 숙지하시고 예매해주세요.</SubTitle>
        </TitleWrapper>
      </HeaderWrapper>
      <SearchWrapper>
        <Select value={searchType} onChange={(e) => setSearchType(e.target.value)}>
          <option value="title">제목</option>
          <option value="content">내용</option>
        </Select>
        <Input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="검색어를 입력하세요"
        />
        <Button onClick={handleSearch}>검색</Button>
      </SearchWrapper>
      <CountWrapper>
        <div>{totalCount} 건 조회되었습니다.</div>
      </CountWrapper>
      <Divider />
      <Table>
        <Thead>
          <tr>
            <Th width="10%">번호</Th>
            <Th width="70%">제목</Th>
            <Th width="20%">등록일</Th>
          </tr>
        </Thead>
        <Tbody>
          {faqs.map((faq) => (
            <tr key={faq.id}>
              <Td>{faq.id}</Td>
              <Td>
                <StyledNavLink to={`/CSCenter/Notices/${faq.id}`} state={{ faq }}>
                  {faq.title}
                </StyledNavLink>
              </Td>
              <Td>{new Date(faq.created_date).toLocaleDateString()}</Td>
            </tr>
          ))}
          {faqs.length === 0 && (
            <tr>
              <Td colSpan="3">게시글이 없습니다.</Td>
            </tr>
          )}
        </Tbody>
      </Table>
      {/* 페이지네이션 컨트롤 추가 */}
      <div style={{ marginTop: '30px', paddingRight: '60px' }}>
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>이전</button>
        <span style={{padding:'10px'}}>{currentPage} / {totalPages}</span>
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>다음</button>
      </div>
      <Outlet />
    </NoticeWrapper>
  );
}
export function Detail() {
  const { id } = useParams();
  const [faq, setFaq] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await fetch(`/api/getNoticePage/${id}`);
      const data = await res.json();
      setFaq(data);
      const commentsRes = await fetch(`/api/getComments/${id}`);
      const commentsData = await commentsRes.json();
      setComments(commentsData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // 댓글 추가 함수
  const handleAddComment = async () => {
    if (newComment.trim() === '') return;

    try {
      const response = await fetch('https://crm.cinechain.co.kr/request/coupon_addComment', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          board_id: faq.board_id,
          post_id: faq.id,
          content: newComment,
          author: faq.author,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to add comment: ${response.statusText}`);
      }

      console.log('Comment added successfully');
      setNewComment('');
      fetchData(); // 댓글 데이터를 다시 가져옵니다.
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  // 댓글 삭제 함수
  const deleteComment = async (commentId) => {
    try {
      const response = await fetch(`https://crm.cinechain.co.kr/request/coupon_deleteComment/${commentId}`, {
        credentials: 'include',
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error(`Failed to delete comment: ${response.statusText}`);
      }

      console.log('Comment deleted successfully');
      fetchData();
    } catch (error) {
      console.error('Error deleting comment:', error);
    }
  };

  // 답글 삭제 함수
  const deleteReply = async (commentId, replyId) => {
    try {
      const response = await fetch(`https://crm.cinechain.co.kr/request/coupon_deleteReply/${replyId}`, {
        credentials: 'include',
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error(`Failed to delete reply: ${response.statusText}`);
      }

      console.log('Reply deleted successfully');
      fetchData();
    } catch (error) {
      console.error('Error deleting reply:', error);
    }
  };

  // 답글 추가 함수
  const handleAddReply = async (commentIndex, replyText) => {
    if (!replyText || replyText.trim() === '') return;

    try {
      const parentCommentId = comments[commentIndex].comment_id;
      const result = await addReply(parentCommentId, replyText, faq?.author);

      if (result) {
        fetchData();
      }
    } catch (error) {
      console.error('Error adding reply:', error);
    }
  };

  // 답글 추가를 위한 API 호출 함수
  const addReply = async (parentCommentId, content, author) => {
    try {
      const response = await fetch('https://crm.cinechain.co.kr/request/coupon_addReply', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          board_id: faq.board_id,
          post_id: faq.id,
          parent_comment_id: parentCommentId,
          content,
          author,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to add reply: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('Reply added successfully:', data);
      return data;
    } catch (error) {
      console.error('Error adding reply:', error);
    }
  };

  // 댓글 수정 함수
  const editComment = async (commentId, content) => {
    try {
      const response = await fetch('https://crm.cinechain.co.kr/request/coupon_updateComment', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          comment_id: commentId,
          content,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to edit comment: ${response.statusText}`);
      }

      console.log('Comment edited successfully');
      fetchData();
    } catch (error) {
      console.error('Error editing comment:', error);
    }
  };

  // 답글 수정 함수
  const handleEditReply = async (replyId, newContent) => {
    try {
      const response = await fetch('https://crm.cinechain.co.kr/request/coupon_updateReply', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reply_id: replyId,
          content: newContent,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update the reply');
      }

      console.log('Reply updated successfully');
      fetchData();
    } catch (error) {
      console.error('Error updating reply:', error);
    }
  };

  if (!faq) {
    return <div>Loading...</div>;
  }

  return (
    <DetailWrapper>
      <DetailHeader>
        {faq.title} ({faq.views})
      </DetailHeader>
      <DetailInfo>
        <span>{new Date(faq.created_date).toLocaleString()}</span>
        <span>작성자: {faq.author} | 조회: {faq.views}</span>
      </DetailInfo>
      <div dangerouslySetInnerHTML={{ __html: faq.content }} />
      {/* <label>데이터가 안나오는 이유 확인하자</label> */}
      {/* 댓글 입력 섹션 */}
      <InputWrapper>
        <TextArea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="댓글을 입력하세요..."
        />
        <Button onClick={handleAddComment}>댓글 작성</Button>
      </InputWrapper>
      {/* 댓글 목록 렌더링 */}
        <CommentView
          key={index}
          index={index}
          comment={comments}
          onDelete={deleteComment}
          onEdit={editComment}
          onReplyAdd={handleAddReply}
          onReplyDelete={deleteReply}
          onReplyEdit={handleEditReply}
        />
    </DetailWrapper>
  );
}

function CommentView({ comment, index, onDelete, onEdit, onReplyAdd, onReplyEdit, onReplyDelete }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [newCommentContent, setNewCommentContent] = useState(comment?.content);
  const [newReply, setNewReply] = useState('');

  const handleEditToggle = () => {
    if (isEditMode) {
      onEdit(comment.comment_id, newCommentContent); // Save 버튼을 클릭할 때 업데이트 수행
    }
    setIsEditMode(!isEditMode); // Edit 모드 토글
  };

  const handleReplyAdd = () => {
    if (newReply.trim() !== '') {
      onReplyAdd(index, newReply); // `index`와 새 답글을 전달합니다.
      setNewReply(''); // 새 답글 필드를 초기화
    }
  };

  return (
    <CommentCard>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <strong>{comment.author}</strong> <span>{new Date(comment.created_date).toLocaleString()}</span>
        </div>
        <div>
          <EditButton onClick={handleEditToggle}>
            {isEditMode ? 'Save' : 'Edit'}
          </EditButton>
          <DeleteButton onClick={() => onDelete(comment.comment_id)}>
            Delete
          </DeleteButton>
        </div>
      </div>
      {!isEditMode ? (
        <p>{comment.content}</p>
      ) : (
        <>
          <hr />
          <InputWrapper>
            <EditTextArea
              value={newCommentContent}
              onChange={(e) => setNewCommentContent(e.target.value)}
              placeholder="댓글을 수정하세요..."
            />
          </InputWrapper>
          <hr />
        </>
      )}
      {comment.replies && comment.replies.map((reply, replyIndex) => (
        <ReplyView
          key={replyIndex}
          reply={reply}
          commentId={comment.comment_id}
          onEdit={onReplyEdit}
          onDelete={onReplyDelete}
        />
      ))}
      <InputWrapper>
        <TextArea
          placeholder="답글을 입력하세요..."
          value={newReply}
          onChange={(e) => setNewReply(e.target.value)}
        />
        <Button onClick={handleReplyAdd}>
          Reply
        </Button>
      </InputWrapper>
    </CommentCard>
  );
}

function ReplyView({ reply, commentId, onEdit, onDelete }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [newReplyContent, setNewReplyContent] = useState(reply.content);

  const handleEditToggle = () => {
    if (isEditMode) {
      onEdit(reply.comment_id, newReplyContent);
    }
    setIsEditMode(!isEditMode); // Edit 모드 토글
  };

  return (
    <ReplyCard>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <strong>{reply.author}</strong> <span>{new Date(reply.created_date).toLocaleString()}</span>
        </div>
        <div>
          <EditButton onClick={handleEditToggle}>
            {isEditMode ? 'Save' : 'Edit'}
          </EditButton>
          <DeleteButton onClick={() => onDelete(commentId, reply.comment_id)}>
            Delete
          </DeleteButton>
        </div>
      </div>
      {!isEditMode ? (
        <p>{reply.content}</p>
      ) : (
        <>
          <hr />
          <EditTextArea
            value={newReplyContent}
            onChange={(e) => setNewReplyContent(e.target.value)}
            placeholder="답글을 수정하세요..."
          />
          <hr />
        </>
      )}
    </ReplyCard>
  );
}
